module.exports = __webpack_public_path__ + "static/media/nMyWalletsIcon.fef37a6f.svg";